const POPOVER_ERRORS = {
  context: "Popover component was not found in the tree",
  children: "Popover.Target component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
};

export { POPOVER_ERRORS };
//# sourceMappingURL=Popover.errors.js.map
